import Cookies from 'js-cookie'
import { cookieDomain } from '../config/index'

const config = {
  domain: cookieDomain
}

export default {
  get (key) {
    return Cookies.get(key, config)
  },
  set (key, value) {
    Cookies.set(key, value, Object.assign({ expires: 1 }, config))
  },
  remove (key) {
    Cookies.remove(key, config)
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js